/**
 * @name objectKeys
 * @summary A version of Object.keys that is typed for TS
 */
export function objectKeys(value) {
    return Object.keys(value);
}
